export function mapByKey<T, R>(o: T, transform: (key: keyof T) => R): R[] {
    const acc: R[] = []
    for (let key in o) {
        acc.push(transform(key))
    }

    return acc
}